import { render, staticRenderFns } from "./PermissionByGroup.vue?vue&type=template&id=148849de&scoped=true&"
import script from "./PermissionByGroup.vue?vue&type=script&lang=js&"
export * from "./PermissionByGroup.vue?vue&type=script&lang=js&"
import style0 from "./PermissionByGroup.vue?vue&type=style&index=0&id=148849de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148849de",
  null
  
)

export default component.exports